import { atom } from 'jotai'
import { TxRaw } from 'cosmjs-types/cosmos/tx/v1beta1/tx'

const unstakeTokenTxRawAtom = atom<TxRaw | null>(null)

export { unstakeTokenTxRawAtom }
